import { schema } from "normalizr"
import user from "../users/item"
import role from "../roles/item"

export default new schema.Object({
  user,
  role,
})
